<template>
  <div>
    <div class="Navbar"
         uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; bottom: #transparent-sticky-navbar">
      <div class="uk-container">
        <nav class="uk-navbar-container NavbarCon" uk-navbar>
          <div class="uk-navbar-left">
            <a class="uk-navbar-toggle uk-hidden@l uk-hidden@xl" uk-navbar-toggle-icon
               uk-toggle="target: #offcanvas-nav" href="#"></a>
            <ul class="uk-navbar-nav">
              <li class="uk-active">
                <router-link to="/" class="LogoLink">
                  <img class="Logo" :src="`${ASSETS_BASE_URL}/images/logo.png`"/>
                </router-link>
              </li>
              <li class="uk-visible@l">
                <router-link to="/">
                  <span class="uk-button-text">{{'home'|translate}}</span>
                </router-link>
              </li>
              <li class="uk-visible@l">
                <a @click="changeRoute('/properties')">
                  <span class="uk-button-text">{{'properties'|translate}}</span>
                </a>
                <div class="uk-navbar-dropdown">
                  <ul class="uk-nav uk-navbar-dropdown-nav">
                    <li>
                      <router-link to="/casamia-nilaveli">
                        <span class="uk-button-text">CASAMIA Nilaveli</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/casamia-colombo">
                        <span class="uk-button-text">CASAMIA Colombo</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/turtle-nest">
                        <span class="uk-button-text">Turtle Nest Rekawa</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="uk-visible@l">
                <router-link to="/excursions">
                  <span class="uk-button-text">{{'excursions'|translate}}</span>
                </router-link>
              </li>
              <li class="uk-visible@l">
                <router-link to="/gallery">
                  <span class="uk-button-text">{{'gallery'|translate}}</span>
                </router-link>
              </li>
              <li class="uk-visible@l">
                <router-link to="/about-us">
                  <span class="uk-button-text">{{'about_us'|translate}}</span>
                </router-link>
              </li>
              <li class="uk-visible@l">
                <router-link to="/inquiry">
                  <span class="uk-button-text">{{'inquiry'|translate}}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="uk-navbar-right">
            <ul class="uk-navbar-nav">
              <li><a href="#" class="HotLine">{{'hot_line'|translate}} : (+94)-770035464</a></li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <!--side nav-->
    <div id="offcanvas-nav" uk-offcanvas="overlay: true">
      <div class="uk-offcanvas-bar uk-background-default SideNav">
        <ul class="uk-nav uk-nav-default">
          <li><a href="#" class="SideNavHotLink">{{'hot_line'|translate}} : (+94)-770035464</a></li>
          <li class="uk-active SideNavLink">
            <router-link to="/">Home</router-link>
          </li>
          <li class="uk-parent SideNavLink">
            <router-link to="/properties">Our Collection</router-link>
            <ul class="uk-nav-sub">
              <li>
                <router-link to="/casamia-nilaveli">CASAMIA Nilaveli</router-link>
              </li>
              <li>
                <router-link to="/casamia-colombo">CASAMIA Colombo</router-link>
              </li>
              <li>
                <router-link to="/turtle-nest">Turtle Nest Rekawa</router-link>
              </li>
            </ul>
          </li>
          <li class="SideNavLink">
            <router-link to="/excursions">Excursions</router-link>
          </li>
          <li class="SideNavLink">
            <router-link to="/gallery">Gallery</router-link>
          </li>
          <li class="SideNavLink">
            <router-link to="/about-us">About Us</router-link>
          </li>
          <li class="SideNavLink">
            <router-link to="/inquiry">Inquiry</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router'

export default {
  name: 'NavbarComponent',
  methods: {
    changeRoute: function (route) {
      router.push(route)
    }
  }
}
</script>

<style scoped>
  .Navbar {
    background: #ffffff;
    box-shadow: 0 0 10px 0 #0000004d;
  }

  .NavbarCon {
    background: #ffffff;
    position: relative;
    z-index: 980;
  }

  .NavbarCon > div > ul > li > a {
    min-height: 60px;
  }

  .LogoLink {
    padding-left: 0;
  }

  .Logo {
    width: 160px;
  }

  .SideNavLink a, .SideNavLink > ul > li a {
    font-size: 20px;
    font-weight: 300;
    color: #696969 !important;
  }

  .SideNavLink a:hover, .SideNavLink > ul > li a:hover {
    font-weight: 400;
    color: #000 !important;
  }

  .HotLine {
    font-weight: 700;
    color: #cf0015;
  }

  .router-link-active > span {
    color: #ca420e !important;
  }

  .SideNavHotLink {
    display: none;
    color: #cf0015 !important;
    font-size: 14px;
    font-weight: bold;
  }

  @media only screen and (max-width: 563px) {
    .Logo {
      width: 160px;
    }
  }

  @media only screen and (max-width: 471px) {
    .SideNavHotLink {
      display: block;
    }

    .HotLine {
      display: none;
    }
  }
</style>
